import gcatCodeIconColor from './gcatCodeIconColor';
import gcatCodeTextColor from './gcatCodeTextColor';
import idToColor from './idToColor';

//
// Build display name/initials/shortName from a member email address.
//
//   alice.bob@eura.fake.fr     → name: alice.bob@eura.fake.fr
//                                shortName: alice.bob
//                                initials: AB
//   alice@eura.fake.fr         → name: alice@eura.fake.fr
//                                shortName: alice
//                                initials: A
//
const fromMemberEmail = (memberEmail) => {
  const prefix = memberEmail.split('@')[0];
  const parts = prefix.split('.').filter((p) => p.length > 0);
  let initials;
  if (parts.length > 1) {
    initials = `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
  } else if (parts.length === 1) {
    initials = parts[0][0].toUpperCase();
  } else {
    initials = '?';
  }
  return ({
    name: memberEmail,
    initials,
    shortName: prefix,
  });
};

const participantNamesAndColor = (
  translate,
  participant,
  cstmrType,
) => {
  if (!participant) {
    return ({
      name: '???',
      color: '#808080',
    });
  }
  const {
    grpGpid, crFname, crLname, crDesc, crUid,
    grpLbl, gcatCode, crWeb,
    member, memberEmail,
  } = participant;

  const color = ((grpGpid === '000000000000grpusers')
              || (grpGpid === undefined)
              || (['business'].includes(cstmrType)))
    ? idToColor(crUid, 0.35, 0)
    : gcatCodeIconColor(gcatCode);
  const txtColor = gcatCodeTextColor(gcatCode);

  // console.log(`nameAndColor cstmrType=${cstmrType} crFname=${
  //   crFname} crUid=${crUid} color=${color}`);

  // Both fname and lname required for the name-based display path —
  // members may have only one or neither, in which case we fall through
  // to the email/Usager path below.
  if (crFname && crLname) {
    if ((grpGpid === '000000000000grpusers') || (grpLbl === 'users')) {
      return ({
        // name: `${crFname[0]}. ${crLname}`,
        name: `${crLname.toUpperCase()} ${crFname}`,
        initials: `${crFname[0]}${crLname[0]}`,
        shortName: `${crLname} ${crFname[0]}.`,
        color,
        txtColor,
      });
    }

    if (['business'].includes(cstmrType)) {
      return ({
        // name: `${crFname[0]}. ${crLname}`,
        name: `${crLname.toUpperCase()} ${crFname}`,
        initials: `${crFname[0]}${crLname[0]}`,
        shortName: `${crLname} ${crFname[0]}.`,
        color,
        txtColor,
      });
    }

    return ({
      name: `${crDesc} `,
      initials: `${crFname[0]}${crLname[0]}`,
      shortName: `${crLname.toUpperCase()} ${crFname[0]}.`,
      color,
      txtColor,
    });
  }

  // Users-category participant (anonymous web user OR member). Both share the
  // same crUid-based "Usager #N" pattern by default. If the participant is a
  // member of the viewer's customer AND the back-town response exposed their
  // memberEmail, switch to email-based naming for that case only.
  if (gcatCode === 'users') {
    if (member && memberEmail) {
      return ({
        ...fromMemberEmail(memberEmail),
        color,
        txtColor,
      });
    }

    return ({
      name: translate('webUser', 'generic', { id: crUid % 100 }),
      initials: `${crUid % 100}`,
      shortName: translate('webUserShort', 'generic', { id: crUid % 100 }),
      color,
      txtColor,
    });
  }

  if (crWeb) {
    return ({
      name: translate('webUser', 'generic', { id: crUid % 100 }),
      initials: `${crUid % 100}`,
      shortName: translate('webUserShort', 'generic', { id: crUid % 100 }),
      color,
      txtColor,
    });
  }

  return ({
    name: grpLbl,
    initials: `${crUid % 100}`,
    shortName: `#${crUid % 100}`,
    color,
    txtColor,
  });
};

export default participantNamesAndColor;
